import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { SchemaRating } from '../../components/specials/home/SchemaRating';

Builder.registerComponent(SchemaRating, {
    name: BUILDER_DIVIDER_NAMES.RatingsDivider,
});
